<template>
  <div @click="onEventAction">

    <qc-table-client-pagination ref="table" :row-class-name="()=>'finder-item'" :loading="loading" :list="list"
      :min-height="`${tableHeight}px`" :max-height="`${tableHeight}px`" :pageSize="pageSize" :currPage="currPage">
      <qc-table-column :label="$t('core.name')" class="table-file" :width="isMobile ? '160px' : ''">
        <template slot-scope="{ item, rowIndex }">
          <div :title="item.name" :data-index="(currPage-1)*pageSize+rowIndex" data-action="openFolderOrFile">
            <div class="cos-icon--32" :class="item.name | FileIcon(item.isDir)"
              :style="`cursor:${item.isDir ? 'pointer':'default'}`"></div>
            <a href="javascript:void(0)" class="table-file__name text-overflow" :class="{'no-highlight':!item.isDir}"
              draggable="false">{{item.name}}</a>
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('cos.storage_class')" :width="isMobile ? '80px' : '100px'">
        <template slot-scope="{ item }">
          <div>
            {{ item.StorageClass | StorageClassShortText }}
          </div>
        </template>
      </qc-table-column>

      <qc-table-column :label="$t('cos.size')" field="size" :width="isMobile ? '80px' : '100px'">
        <template slot-scope="{ item }">
          <div>
            {{item.size | formatSize}}
          </div>
        </template>
      </qc-table-column>
      <qc-table-column :label="$t('cos.modify_time')" field="mtime" :width="isMobile ? '140px' : '160px'">
        <template slot-scope="{ item }">
          <div>
            {{item.mtime * 1000 | formatDate}}
          </div>
        </template>
      </qc-table-column>
      <qc-table-column :label="$t('cos.operation')" :width="isMobile ? '100px' : '140px'">
        <template slot-scope="{ item, rowIndex }">
          <div class="tc-g cos-table-operate">
            <div class="tc-g-u-1-3">
              <div v-if="!item.isDir && item.StorageClass !== 'ARCHIVE'" class="container-icon"
                :data-index="(currPage-1)*pageSize+rowIndex" data-action="download">
                <div class="cos-icon--16 download">
                </div>
              </div>

              <!-- 占位 -->
              <div class="custom-operate-span container-icon no-hover" v-else>
                <div class="cos-icon--16" style="pointer-events: none;"></div>
              </div>
            </div>
            <div class="tc-g-u-1-3" v-if="!disabledBtn.delete">
              <div class="container-icon" :data-index="(currPage-1)*pageSize+rowIndex" data-action="delete">
                <div class="cos-icon--16 delete"></div>
              </div>
            </div>
          </div>
        </template>
      </qc-table-column>

      <template slot="empty-tips">
        <div class="table-body blank" :style="`height:${tableHeight - 50}px;min-height:200px;`">
          <template v-if="!hasAuthority">
            <div class="blank-img no-access"></div>
            <div class="blank-title">{{$t('cos.no_permission')}}</div>
          </template>
          <template v-else-if="isExpired">
            <div class="blank-img no-access"></div>
            <div class="blank-title">{{$t('cos.link_expired')}}</div>
          </template>
          <template v-else-if="tableShowErr">
            <div class="blank-img no-access"></div>
            <div class="blank-title">{{translateTableErrorShow}}</div>
          </template>
          <template v-else>
            <template v-if="searchStatus.isSearchDone">
              <div class="blank-img lost"></div>
              <div class="blank-title">{{$t('cos.no_results_found')}}</div>
              <div class="blank-help">{{$t('cos.try_different_keywords')}}</div>
            </template>
            <template v-else-if="!searchStatus.isSearchDone && !searchStatus.isSearching">
              <div class="blank-img empty"></div>
              <div class="blank-title">{{$t('cos.folder_is_empty')}}</div>
            </template>
          </template>
        </div>
      </template>

      <template slot="pagination">
        <slot name="footer"></slot>
      </template>
    </qc-table-client-pagination>
  </div>
</template>

<script>
import device from 'current-device';

export default {
  model: {
    prop: 'list',
    event: 'update:list',
  },
  props: {
    list: Array,
    loading: {
      Type: Boolean,
      required: true,
      default: false,
    },
    hasAuthority: {
      type: Boolean,
      required: true,
      default: true,
    },
    isExpired: Boolean,
    tableShowErr: Object,
    searchStatus: {
      type: Object,
      required: true,
    },
    currPage: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    disabledBtn: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableHeight: 300,
    };
  },
  mounted() {
    // 获取浏览器可视区域高度，动态加载表格高度
    this.renderClientHeight();
    window.onresize = () => {
      this.renderClientHeight();
    };
  },
  computed: {
    isMobile() {
      return device.mobile();
    },
    translateTableErrorShow() {
      if (!this.tableShowErr) return '';
      const { code } = this.tableShowErr;
      switch (code) {
        case 'NoSuchSid':
          return this.$t('error.current_share_link_does_not_exist');
        case 'ExpiredUrl':
          return this.$t('error.current_share_link_has_expired');
        default:
          return this.$t('error.network_busy_please_refresh_page');
      }
    },
  },
  methods: {
    renderClientHeight() {
      const headerHeight = 97;
      const offsetTop = 145;
      const padding = 40;
      const { clientHeight } = document.documentElement;
      const pagination = 50;
      let tableHeight = clientHeight - offsetTop - headerHeight - padding;
      if (this.list.length > 100) {
        tableHeight -= pagination;
      }
      this.tableHeight = Math.max(tableHeight, 200);
    },
    onEventAction(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.index) {
        target = target.parentNode;
      }
      const { index, action } = target.dataset;
      this.action = action || '';
      if (action) {
        this.item = this.list[index];
        switch (action) {
          case 'dropmenu': {
            this.openDropmenu(target);
            break;
          }
          default:
            this.onAction(action);
            break;
        }
      }
    },
    onAction(action) {
      const { item } = this;
      const val = { item, action };
      this.$emit('on-action', val);
    },
  },
};
</script>

<style scoped lang="scss">
$xs: 360px;
$sm: 600px;
$md: 768px;
::v-deep .tc-15-table-box {
  @media screen and (max-width: $md) {
    .cos-icon--32 {
      width: 18px;
      height: 18px;
    }
    .table-file__name {
      max-width: 170px;
    }
  }
  @media screen and (max-width: $sm) {
    .cos-icon--32 {
      width: 16px;
      height: 16px;
    }
    .table-file__name {
      max-width: 105px;
    }
  }
}
.tc-15-table-panel .tc-15-table-fixed-body {
  a.table-file__name.no-highlight:hover {
    color: #08090a;
    cursor: default;
  }
}
.tc-g.cos-table-operate {
  .tc-g-u-1-3 {
    padding-right: 0;
  }
}
</style>
